import script from "./SchoolPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./SchoolPreview.vue?vue&type=script&lang=ts&setup=true"

export default script